import Header from '../../component/Header';
import './Contact.css';

const Contact = () => {
    return (
        <div>
            <Header/>
        </div>
    );
};

export default Contact;